import { createContext } from "react";
import { Dispatch, SetStateAction } from "react";
import type { SortModel } from "components/ColumnFilters/types";
import type { ColumnFilterPayloadItem } from "./columnFilterUtils";

export interface AlertsContextType {
  groupedData: any[];
  totalAlerts: number;

  page: number;
  pageSize: number;

  setPage: Dispatch<SetStateAction<number>>;
  setPageSize: Dispatch<SetStateAction<number>>;

  filterOptions: any;

  sortingInfo: any;
  setSortingInfo: (value: any) => void;

  isLoading: boolean;

  selectedTile: any;

  groupBy: string;
  setGroupBy: (value: string) => void;

  groupByList: any[];

  includeGroupByMenuColumns: any[];

  handleGroupToggle: (...args: any[]) => void;

  handleShowMoreClick: (...args: any[]) => void;

  loadingGroupId: string | null;

  isDataOpsAdmin: boolean;

  handleManageSop: (...args: any[]) => void;

  alertCountView: 'overall' | 'unique';

  columnFilters: ColumnFilterPayloadItem[];
  handleColumnFilterChange: (payload: ColumnFilterPayloadItem[], sortModel: SortModel) => void;
  getColumnFilterValues: (field: string) => Promise<any[]>;
}

export const AlertsContext =
  createContext<AlertsContextType | null>(null);